export { default } from './Table';
export type { Props, Props as TableProps } from './Table';
